/**
 * PHASE 10 — calibration UX math.
 *
 * The manual calibration flow is "point the top of the phone at a landmark
 * whose bearing you know (true north is the common case), then declare it".
 * The heading is the azimuth of the device's +y axis (hud.ts); the yaw offset
 * needed to make that reading 0 is exactly -heading, wrapped into
 * [-180, 180). The sign is pinned by integration tests against
 * applyCalibration + deviceHeadingDeg.
 */

/** Offset (degrees, [-180, 180)) that makes the current heading read 0. */
export function calibrationOffsetForNorth(headingDeg: number): number {
  let offset = -headingDeg % 360;
  if (offset < -180) offset += 360;
  if (offset >= 180) offset -= 360;
  return offset;
}

/** Human-readable offset for the settings readout. */
export function formatOffsetDeg(offsetDeg: number): string {
  if (Math.abs(offsetDeg) < 0.05) return "0° (aligned)";
  const sign = offsetDeg < 0 ? "−" : "+";
  return `${sign}${Math.abs(offsetDeg).toFixed(1)}°`;
}